import { useTranslation } from 'react-i18next';
import type { GridListViewColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { Typography } from '@mui/material';

import type { RefuelDataGridRow } from '../../types/RefuelDataGridRow.types';

import { ListViewCellContainer, ListViewCellContent, RefuelMetricsGrid } from './RefuelDataGridListViewCell.styles';

type RefuelsListViewCellProps = {
  params: GridRenderCellParams<RefuelDataGridRow>;
};

function RefuelDataGridListViewCell({ params }: RefuelsListViewCellProps) {
  const { t } = useTranslation();

  return (
    <ListViewCellContainer direction="row">
      <ListViewCellContent>
        {/* Existing typography variants change the compact list row height. */}
        <Typography data-qa-element-id="refuel_place_label" variant="body2" fontWeight={600} fontSize="16px">
          {params.row.refuelPlace}
        </Typography>
        <Typography data-qa-element-id="refuel_date_label" variant="body2" color="text.secondary">
          {params.row.refuelDate}
        </Typography>
        <RefuelMetricsGrid>
          <Typography variant="body2" data-qa-element-id="start_fuel_label">
            {t('refuels.table.header.startFuelLevel')}
          </Typography>
          <Typography variant="body2" data-qa-element-id="refuel_amount_label">
            {t('refuels.table.header.amountRefuels')}
          </Typography>
          <Typography variant="body2" data-qa-element-id="stop_fuel_label">
            {t('refuels.table.header.stopFuelLevel')}
          </Typography>
          <Typography variant="body2" fontWeight={600} data-qa-element-id="start_fuel_value">
            {params.row.startFuelLevel.toFixed(1)}
          </Typography>
          <Typography variant="body2" fontWeight={600} data-qa-element-id="refuel_amount_value">
            {params.row.amountRefuels.toFixed(1)}
          </Typography>
          <Typography variant="body2" fontWeight={600} data-qa-element-id="stop_fuel_value">
            {params.row.stopFuelLevel.toFixed(1)}
          </Typography>
        </RefuelMetricsGrid>
      </ListViewCellContent>
    </ListViewCellContainer>
  );
}

function renderRefuelsListViewCell(params: GridRenderCellParams<RefuelDataGridRow>) {
  return <RefuelDataGridListViewCell params={params} />;
}

export const REFUELS_LIST_VIEW_COLUMN: GridListViewColDef<RefuelDataGridRow> = {
  field: 'listView',
  renderCell: renderRefuelsListViewCell,
};
